<template>
    <div>
        <div class="white--text blue darken-2" id="jumbo">
        <v-container>
            <v-row align="center">
                <v-col class="text-left" cols="12">
                <h1 class="display-1 font-weight-bold mb-4">Piškotki</h1>
                <p>Za boljšo uporabniško izkušnjo in za predvajanje video vsebin uporabljamo piškotke.</p>
                </v-col>
            </v-row>
        </v-container>
      </div>
      <v-container>
            <p>Uporabljeni so piškotki podjetja Google za zagotavljanje posnetkov iz YouTube-a.</p>
            <p>Stran uporablja YouTube funkcijo no-cookies, ki omogoča, da se piškotki naložijo le ob dejanskem predvajanju videposnetka.</p>
            <p>Link za vir: <a href="https://support.google.com/youtube/answer/171780?hl=en-GB">Klik</a></p>
      </v-container>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>